import React from 'react';
import { Input, Button, Segment, Icon, COLORS, Text, Spacer } from 'components';
import http from 'data-graphql/http';
import styled from 'styled-components';
import LogoSrc from 'assets/logo.svg';
import MTILogo from 'assets/mtiLogoBottomAligned.png';
import { toast } from 'react-toastify';
import { isMTI } from 'helpers';

const Body = styled.div`
  min-height: 100vh;
  background: linear-gradient(
    ${isMTI ? COLORS.darkBlue : '#000000'},
    ${isMTI ? COLORS.lightBlue : COLORS.red}
  );
`;
const Form = styled.form`
  width: 400px;
  max-width: 100%;
  margin: auto;
  padding-top: 100px;
`;
const Logo = styled.img`
  width: 100%;
  padding: 30px 40px;
`;

export default class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      email: ''
    };
  }

  forgotOrgInfo(e) {
    e.preventDefault();

    if (!this.state.email) {
      return toast.error('Please enter an email!', { autoclose: false });
    }

    http()
      .post('/forgot-org-info', {
        email: this.state.email
      })
      .then(res => {
        if (res.success && res.message) {
          toast.success(res.message);
          this.props.history.push('/');
        }
      })
      .catch(e => {
        return e;
      });
  }

  backToLogin = () => {
    this.props.history.push('/');
  };

  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  render() {
    return (
      <Body>
        <Form onSubmit={this.forgotOrgInfo.bind(this)}>
          <Logo src={isMTI ? MTILogo : LogoSrc} onClick={this.backToLogin} />
          <div style={{ textAlign: 'center' }}>
            <Text white>Forgot your organization login?</Text>
          </div>

          <Spacer size="20px" />
          <Segment>
            <Input
              value={this.state.email}
              name="email"
              onChange={this.handleChange}
              placeholder="Email"
              icon={<Icon name="email" />}
            />

            <Spacer size="20px" />

            <Button large fluid>
              Submit
            </Button>
          </Segment>
        </Form>
        <Spacer size="50px" />
      </Body>
    );
  }
}
